<div class="l-top-navi" role="navigation">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a id="booking-list-header-back" class="l-top-navi__back-link" (click)="eventBack()"
            ><span class="u-visually-hidden">Back to Previous Page</span></a
          >
        </div>
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="displayTitle | staticMsg"></h1>
        </div>
      </div>
    </div>
  </div>
</div>
